import { lazyLoad } from '@utils/loadable';

export const PiecripAccountPage = lazyLoad(
  () => import('./index'),
  (module) => module.PiecripAccountPage
);
